import { render, staticRenderFns } from "./SettingPreviewContent.vue?vue&type=template&id=2146db74&scoped=true"
import script from "./SettingPreviewContent.vue?vue&type=script&lang=js"
export * from "./SettingPreviewContent.vue?vue&type=script&lang=js"
import style0 from "./SettingPreviewContent.vue?vue&type=style&index=0&id=2146db74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146db74",
  null
  
)

export default component.exports